
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Question} from '@/lib/Question';

@Component({})
export default class VidNumberQuestion extends Vue {
  @Prop() public question: Question;
}
